import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const UnitItemPage = lazy(() => import('./UnitItemPage'));

const UnitItemPageConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.user,
   routes: [
      {
         path: '/operator/masterdata/unititems',
         element: <UnitItemPage />,
      },
   ],
};

export default UnitItemPageConfig;
